import { createSlice } from '@reduxjs/toolkit';
import { getAllDrawersDivisions } from './thunks';

// Initial state for Redux store:
export const initialStateDrawersDivisions = {
  drawers_divisions: [],
  loading: false,
};

const drawersdivisionsSlice = createSlice({
  name: 'drawersdivisions',
  initialState: initialStateDrawersDivisions, // Define initial state
  reducers: {
    setDrawersDivisions: (state: any, action: any) => {
      state.drawers_divisions = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllDrawersDivisions.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllDrawersDivisions.fulfilled, (state, action) => {
      state.drawers_divisions = action.payload;
      state.loading = false;
    });
  },
});

// Export actions generated by "createSlice()":
export const { setDrawersDivisions } = drawersdivisionsSlice.actions;

// Export reducer generated by "createSlice()":
export default drawersdivisionsSlice.reducer;
